import { useEffect } from 'react';
import type { ProfileState } from '@/hooks/useUser';
import { usePlanById } from '@/hooks/useUserPlans';
import { formatDateForBraze, useBraze } from '@/components/Braze';

type Props = {
  user: ProfileState;
};

export const BrazeLogUserSubscribed = ({ user }: Props) => {
  const { logCustomEvent } = useBraze();
  const { data: userPlan } = usePlanById({ planId: user.billing.plan });

  useEffect(() => {
    if (typeof userPlan !== 'undefined') {
      logCustomEvent('user_subscribed', {
        productId: userPlan.name,
        planId: userPlan.id,
        planAmount: userPlan.amount,
        planInterval: userPlan.interval,
        planExpiryDate: formatDateForBraze(user.billing.currentPeriodEnd),
        subscriptionDate: formatDateForBraze(),
        couponUsed: user.billing.coupon.name,
      });
    }
  }, [userPlan]);

  return null;
};
